import React from "react";
import "./../../SCSS/MostSharedComponents/_protection.scss";
import RatingBlock from "./RatingBlock";
import Heading6 from "./../Font/Heading6";
import Price from "../Font/Price";
import OldPrice from "../Font/OldPrice";
function Protection({ title, tagline, rating, totalRatings, protection }) {
  const handleChange = (e) => {

  };
  return (
    <div className="product__protect__block">
      <Heading6 text={`${title} `} span={true} />
      <span className="product__block__title__span">{`(${tagline})`}</span>
      <RatingBlock
        size={22}
        rating={rating}
        totalRatings={totalRatings}
        fillColor="#DC3A1A"
        emptyColor="#C8C8C8"
      />

      {/* <div className="product__protect__selection__block">
        {protection.map((protect, protectIndex) => {
          return (
            <div key={protect.id} className="product__protection__selection">
              <div className="product__protection__form__block">
                <input
                  type="checkbox"
                  className="product__input__check"
                  name="pincode"
                  value={1}
                  onChange={handleChange}
                />
                <p className="product__protection__text">
                  {protect.protectionText}
                </p>
              </div>
              <div className="product__protection__price__block">
                <p className="product__protection__price">
                  <Price price={protect.price} size="heading7" currency={"SAR"} />
                </p>
                <p className="product__protection__monthly__price">
                  <OldPrice
                    preText="About"
                    oldPrice={`${protect.price}`}
                    postText="/mo"
                    size="text5"
                    marginBottom={0}
                  />
                </p>
              </div>
            </div>
          );
        })}
      </div> */}
    </div>
  );
}

export default Protection;
